/*
 * @Author: cascade
 * @Description: 定时开奖组件（列表样式）
 */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';
import moment from 'moment';
import utils from '../../utils/utils';
import px2rem from '../../utils/px2rem';
import Request from '../../utils/request';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import './style.less';

class PipelineTimedLottery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prizeList: [],
      now: moment(),
      tick: 0,
      modalVisible: false,
      modalClosing: false,
      isLogin: false,
      drawInfo: {},
      helpStatus: null,
      tips: ''
    };
    this.task_id = utils.getQueryString('id') || '';
    this.loginInterVal = null;
    this.app_version = utils.getVersion();
    this.ticker = null;
  }

  async componentDidMount() {
    // 先启动倒计时，避免请求失败导致未启动
    this.getLotteryDetail();
    let drawInfo = {};

    if (this.task_id) {
      try {
        drawInfo = await this.getLotteryInfo();
      } catch (e) {
        drawInfo = {};
      }
    }

    if (this.task_id) {
      // task_id 存在时，需要执行助力流程，先进行登录判断
      const isLogin = await this.queryLoginStatus();
      if (!isLogin) {
        this.setState({
          modalVisible: true,
          drawInfo,
          isLogin
        }, () => {
          this.startTicker();
        });
      } else {
        const { status, tips } = await this.onDrawHelp();
        this.setState({
          modalVisible: true,
          helpStatus: status,
          drawInfo,
          isLogin,
          tips
        }, () => {
          this.startTicker();
        });
      }
    } else {
      this.setState({
        drawInfo
      }, () => {
        this.startTicker();
      })
    }
    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
      false
    );
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.removeInterval();
  }

  // 获取抽奖详情
  getLotteryDetail = () => {
    let { prizeList = [] } = this.props.config || {};
    if (prizeList.length > 0) {
      const ids = prizeList.map(item => item.actId).join(',');
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/activity/list',
        method: 'get',
        withCredentials: true,
        params: {
          ids
        }
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0 && data && data.length > 0) {
          prizeList = prizeList.map(item => {
            const target = data.find(i => i.id == item.actId);
            if (target) {
              const { name, start_time, end_time, price, status } = target;
              return {
                ...item,
                name: item.name || name,
                startTime: start_time,
                endTime: end_time,
                price,
                status
              }
            }
            return item;
          })
          this.setState({
            prizeList
          });
        }
      }).catch((error) => {})
    }
  }

  // 活动助力信息接口
  getLotteryInfo = () => {
    return new Promise((resolve, reject) => {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/help/info',
        method: 'get',
        withCredentials: true,
        params: {
          task_id: this.task_id
        }
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          resolve(data);
        } else {
          resolve({});
        }
      }).catch((error) => {
        reject({});
      })
    })
  }

  // 助力接口
  onDrawHelp = () => {
    return new Promise((resolve, reject) => {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/help',
        method: 'post',
        withCredentials: true,
        data: {
          task_id: Number(this.task_id)
        }
      }).then(res => {
        const { status, data, msg } = res.data;
        if (status === 0) {
          resolve(data);
        } else {
          window.Jockey.send('toast', {
            text: msg
          });
          resolve({
            status: -1,
            tips: ''
          });
        }
      }).catch((error) => {
        reject({});
      })
    });
  }

  // 启动/恢复倒计时
  startTicker = () => {
    if (this.ticker) {
      clearInterval(this.ticker);
      this.ticker = null;
    }
    // 立即刷新一次，避免等待首个间隔
    this.setState(prev => ({ now: moment(), tick: (prev.tick + 1) % 1000000000 }));
    this.ticker = setInterval(() => {
      this.setState(prev => ({ now: moment(), tick: (prev.tick + 1) % 1000000000 }));
    }, 1000);
  };

  // 页面可见性变化时暂停/恢复
  handleVisibilityChange = () => {
    if (document.hidden) {
      if (this.ticker) {
        clearInterval(this.ticker);
        this.ticker = null;
      }
    } else {
      this.startTicker();
    }
  };

  // 移除定时器
  removeInterval() {
    this.loginInterVal && clearInterval(this.loginInterVal);
    this.loginInterVal = null;
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = null;
    this.ticker && clearInterval(this.ticker);
    this.ticker = null;
    this.countdownTimer && clearTimeout(this.countdownTimer);
    this.countdownTimer = null;
  }

  // 登录
  handleLogin = () => {
    if (utils.isShihuo()) {
      // 未登陆，请先进行微信登陆
      if (this.loginInterVal) {
        return;
      }
      this.setState({
        modalVisible: false,
        modalClosing: false
      });
      if (!utils.isAndroid() && (utils.SHDiffVersion(this.app_version, '6.86.0'))) {
        this.judgeIsLogin();
      } else {
        window.Jockey.send("subscribe", {}, (publishData) => {
          if (publishData.type === "loginSuccess") {
            this.loginInterVal = setInterval(async () => {
              const isLogin = await this.queryLoginStatus();
              if (isLogin) {
                clearInterval(this.loginInterVal);
                this.loginInterVal = null;

                const { status, tips } = await this.onDrawHelp();
                this.setState({
                  modalVisible: status !== -1,
                  helpStatus: status,
                  isLogin: true,
                  tips
                });
              }
            }, 500);
          }
        });
      }
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
    }
  }

  // 轮询判断是否登陆成功
  judgeIsLogin = () => {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = setInterval(() => {
      const { isLogin } = this.state;
      if (!isLogin) {
        const CookieUA = utils.getCookie('ua');
        const CookieU = utils.getCookie('u');
        if (CookieUA && CookieU) {
          Promise.all([CookieUA, CookieU]).then(result => {
            this.setState({
              isLogin: result && result[0] && result[1]
            }, async() => {
              if (this.state.isLogin) {
                this.removeInterval();
                const { status, tips } = await this.onDrawHelp();
                this.setState({
                  modalVisible: status !== -1,
                  helpStatus: status,
                  isLogin: true,
                  tips
                });
              }
            });
          })
        }
      } else {
        this.removeInterval();
      }
    }, 500);
  }

  // 查询登录状态
  queryLoginStatus = () => {
    return new Promise((resolve, reject) => {
      try {
        Request({
          url: `https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=${this.pageId}&need_wechat_info=false&complicate=true`,
          method: 'get',
          withCredentials: true,
        }).then(res => {
          const { status, data } = res.data;
          if (status === 0) {
            if (data.user_info && data.user_info.uid) {
              this.removeInterval();
              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            // 用户未登录
            resolve(false);
          }
        })
      } catch (error) {
        reject(false);
      }
    })
  }

  // 获取活动状态和文案
  getActivityState = (item) => {
    const { startTime = '', endTime = '' } = item || {};
    const { now } = this.state;

    const start = startTime ? moment(startTime * 1000) : null;
    const end = endTime ? moment(endTime * 1000) : null;

    // 状态1: 进行中 (startTime <= now < endTime)
    if (start && end && now.isSameOrAfter(start) && now.isBefore(end)) {
      const d = moment.duration(end.diff(now));
      const days = Math.floor(d.asDays());
      const hours = d.hours();
      const minutes = d.minutes();
      const seconds = d.seconds();
      return {
        slogan: `${days > 0 ? days + '天' : ''}<span class="count-down">${
          hours < 10 ? '0' + hours : hours
        }:${minutes < 10 ? '0' + minutes : minutes}:${
          seconds < 10 ? '0' + seconds : seconds
        }</span>后活动结束`,
        statusClass: 'status-inprogress',
      };
    }

    // 状态2: 未开始 (startTime > now)
    if (start && now.isBefore(start)) {
      const d = moment.duration(start.diff(now));
      const days = Math.floor(d.asDays());
      const hours = d.hours();
      const minutes = d.minutes();
      const seconds = d.seconds();
      return {
        slogan: `${days > 0 ? days + '天' : ''}<span class="count-down">${
          hours < 10 ? '0' + hours : hours
        }:${minutes < 10 ? '0' + minutes : minutes}:${
          seconds < 10 ? '0' + seconds : seconds
        }</span>后活动开始`,
        statusClass: 'status-notstarted',
      };
    }

    // 状态3: 已结束 (endTime < now)
    if (start && end && now.isAfter(end)) {
      return {
        slogan: `${end.format('M月D日HH:mm')}活动已开奖`,
        statusClass: 'status-ended',
      };
    }

    // 默认或异常状态
    return {
      slogan: '活动已结束',
      statusClass: 'status-ended',
    };
  };

  handleClick = (item, index, remain_time) => {
    const link = `shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=TimedLotteryDraw&options=${encodeURIComponent(JSON.stringify({
      act_id: item.actId,
    }))}`;
    utils.jumpToUrl(this.props.routeParams, link, link, {}, -1, this.props, false, {
      ptiId: `${this.props.templatePti}:timedLottery:${index + 1}`,
      ptiName: '查看活动',
      bizExtra: {
        text: item.name,
        activity_id: item.actId,
        remain_time: remain_time,
        model_block: '查看活动'
      }
    });
  };

  // 助力结果弹窗按钮点击
  handlePopClick = (act_id, helpStatus, tips) => {
    const link = `shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=TimedLotteryDraw&options=${encodeURIComponent(JSON.stringify({
      act_id,
    }))}`;
    utils.jumpToUrl(this.props.routeParams, link, link, {}, -1, this.props, false, {
      ptiId: `${this.props.templatePti}:timedLotteryPopGo:`,
      ptiName: 'timedLotteryPopGo',
      bizExtra: {
        text: helpStatus === 0 ? '助力成功，感谢你的助力！' : tips,
        button_name: '我也要参与，查看活动'
      }
    });
    this.setState({
      modalVisible: false,
      modalClosing: false,
    })
  };

  openModal = (item) => {
    this.setState({ modalVisible: true, modalClosing: false });
  };

  closeModal = () => {
    if (!this.state.modalVisible) return;
    this.setState({ modalClosing: true });
    setTimeout(() => {
      this.setState({ modalVisible: false, modalClosing: false });
    }, 300);
  };

  render() {
    const { baseConfig = {} } = this.props.config || {};
    const { modalVisible, modalClosing, isLogin, drawInfo = {}, helpStatus, tips, prizeList = [] } = this.state;

    if (!prizeList || !prizeList.length) return null;

    return (
      <div
        className="pipeline-timed-lottery"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
        }}
      >
        <div className="tl-list">
          {prizeList.map((it, idx) => {
            const activityState = this.getActivityState(it);
            return (
              <div
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                  ptiId: `${this.props.templatePti}:timedLottery:${idx + 1}`,
                  ptiName: 'timedLottery',
                  bizExtra: {
                    text: it.name,
                    activity_id: it.actId,
                    remain_time: activityState.slogan,
                    model_block: '查看活动'
                  }
                }))}
                className="tl-item"
                key={idx}
                onClick={() => this.handleClick(it, idx, activityState.slogan)}
              >
                {it.image ? (
                  <div className="tl-img-wrap">
                    <LazyLoadImage
                      width={px2rem('108px')}
                      height={px2rem('108px')}
                      className="tl-img"
                      src={utils.formatImgUrl(it.image, this.props.webpSupport)}
                      alt="奖品图"
                      effect="opacity"
                    />
                    <div className="tl-img-mask" />
                  </div>
                ) : null}
                <div className="tl-info">
                  <div
                    className={`tl-status ${activityState.statusClass}`}
                    dangerouslySetInnerHTML={{ __html: activityState.slogan }}
                  />
                  <div className="tl-name">{it.name || '奖品名称'}</div>
                  <div className="tl-price">
                    <span className="now">
                      <span className="now-symbol">¥</span>
                      <span className="now-price">0</span>
                    </span>
                    {it.price > 0 ? (
                      <span className="origin">¥{it.price}</span>
                    ) : null}
                  </div>
                </div>
                <div className="tl-action">
                  查看活动
                </div>
              </div>
            );
          })}
        </div>

        {
          (modalVisible && !isLogin) ? (
            <div
              ref={ele => {
                if (ele) {
                  this.props.exp && this.props.exp(ele);
                }
              }}
              data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                ptiId: `${this.props.templatePti}:timedLotteryPopShow:`,
                ptiName: 'timedLotteryPopShow',
                bizExtra: {
                  text: '好友正在参与抽奖活动，帮TA助力！'
                }
              }))}
              className={`tl-modal-root ${modalClosing ? 'tl-leave' : 'tl-enter'}`}
            >
              <div className={`tl-mask ${modalClosing ? 'tl-leave' : 'tl-enter'}`} onClick={this.closeModal} />
              <div className={`tl-dialog type_1 ${modalClosing ? 'tl-leave' : 'tl-enter'}`}>
                <div className="tl-dialog-title">
                  <img src={drawInfo.avatar} alt="" className='avatar' />
                  好友正在参与抽奖活动
                </div>
                <div className="tl-dialog-title">
                  帮TA助力！
                </div>
                <div className="tl-dialog-card">
                  {drawInfo && drawInfo.img ? (
                    <img className="tl-card-img" src={utils.formatImgUrl(drawInfo.img, this.props.webpSupport)} alt="奖品" />
                  ) : null}
                  <div className="tl-card-info">
                    <div className="tl-card-name">{(drawInfo && drawInfo.name)}</div>
                    <div className="tl-card-tag">
                      <span>限时免费抽</span>
                      <span className="tl-card-tag-price">¥{drawInfo.price}</span>
                    </div>
                  </div>
                </div>
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                    ptiId: `${this.props.templatePti}:timedLotteryPopGo:`,
                    ptiName: 'timedLotteryPopGo',
                    bizExtra: {
                      text: '好友正在参与抽奖活动，帮TA助力！',
                      button_name: '去登录帮TA助力',
                    }
                  }))}
                  className="tl-dialog-btn"
                  onClick={() => {
                    utils.uploadTrack(this.props, {}, {
                      ptiId: `${this.props.templatePti}:timedLotteryPopGo:`,
                      ptiName: 'timedLotteryPopGo',
                      bizExtra: {
                        text: '好友正在参与抽奖活动，帮TA助力！',
                        button_name: '去登录帮TA助力',
                      }
                    })
                    this.handleLogin()
                  }}
                >
                  去登录帮TA助力
                </div>
                <img
                  src="https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png"
                  alt=""
                  className="tl-dialog-close"
                  onClick={() => {
                    utils.uploadTrack(this.props, {}, {
                      ptiId: `${this.props.templatePti}:timedLotteryPopClose:`,
                      ptiName: 'timedLotteryPopClose',
                      bizExtra: {
                        text: '好友正在参与抽奖活动，帮TA助力！'
                      }
                    });
                    this.closeModal();
                  }}
                />
              </div>
            </div>
          ) : null
        }

        {
          (modalVisible && isLogin && helpStatus >= 0) ? (
            <div
              ref={ele => {
                if (ele) {
                  this.props.exp && this.props.exp(ele);
                }
              }}
              data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                ptiId: `${this.props.templatePti}:timedLotteryPopShow:`,
                ptiName: 'timedLotteryPopShow',
                bizExtra: {
                  text: helpStatus === 0 ? '助力成功，感谢你的助力！' : tips,
                }
              }))}
              className={`tl-modal-root ${modalClosing ? 'tl-leave' : 'tl-enter'}`}
            >
              <div className={`tl-mask ${modalClosing ? 'tl-leave' : 'tl-enter'}`} onClick={this.closeModal} />
              <div className={`tl-dialog type_2 ${modalClosing ? 'tl-leave' : 'tl-enter'}`}>
                <div className="tl-dialog-title">
                  { helpStatus === 0 ? '助力成功，感谢你的助力！' : tips }
                </div>
                <div className="tl-dialog-subtitle">
                  <img src={drawInfo.avatar} alt="" className='avatar' />
                  <span>{helpStatus === 0 ? '好友额外获得1张抽奖码' : '好友正在参与抽奖活动'}</span>
                </div>
                <div className="tl-dialog-card">
                  {drawInfo && drawInfo.img ? (
                    <img className="tl-card-img" src={utils.formatImgUrl(drawInfo.img, this.props.webpSupport)} alt="奖品" />
                  ) : null}
                  <div className="tl-card-info">
                    <div className="tl-card-name">{(drawInfo && drawInfo.name)}</div>
                    <div className="tl-card-tag">
                      <span>限时免费抽</span>
                      <span className="tl-card-tag-price">¥{drawInfo.price}</span>
                    </div>
                  </div>
                </div>
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                    ptiId: `${this.props.templatePti}:timedLotteryPopGo:`,
                    ptiName: 'timedLotteryPopGo',
                    bizExtra: {
                      text: helpStatus === 0 ? '助力成功，感谢你的助力！' : tips,
                      button_name: '我也要参与，查看活动',
                    }
                  }))}
                  className="tl-dialog-btn"
                  onClick={() => this.handlePopClick(drawInfo.act_id, helpStatus, tips)}
                >
                  我也要参与，查看活动
                </div>
                <img
                  src="https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png"
                  alt=""
                  className="tl-dialog-close"
                  onClick={() => {
                    utils.uploadTrack(this.props, {}, {
                      ptiId: `${this.props.templatePti}:timedLotteryPopClose:`,
                      ptiName: 'timedLotteryPopClose',
                      bizExtra: {
                        text: helpStatus === 0 ? '助力成功，感谢你的助力！' : tips
                      }
                    });
                    this.closeModal();
                  }}
                />
              </div>
            </div>
          ) : null
        }
      </div>
    );
  }
}

PipelineTimedLottery.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineTimedLottery };
export default PipelineTimedLottery;



// WEBPACK FOOTER //
// ./components/pipeline-timedLottery/index.js